import { IDateFilterParams } from 'ag-grid-community';
import { DateTime } from 'luxon';

export interface FilterParams {
  dateComparator: { buttons: string[]; comparator: NonNullable<IDateFilterParams['comparator']> };
  dateWithTimeComparator: { comparator: IDateFilterParams['comparator'] };
  percentageFilter: {
    defaultOption: IDateFilterParams['defaultOption'];
  };
  textFilterOptions: { filterOptions: IDateFilterParams['filterOptions'] };
}

type FilterParamsKeys = keyof FilterParams;

const filterParams: FilterParams = {
  dateComparator: {
    buttons: ['clear'],
    comparator(filterDateValue: Date, cellDateValue: Date | string): number {
      if (typeof cellDateValue === 'string') {
        const dateParts = cellDateValue.split('-');
        if (dateParts.length === 3) {
          const year = Number(dateParts[0]);
          const month = Number(dateParts[1]) - 1;
          const day = Number(dateParts[2]);
          cellDateValue = new Date(year, month, day);
        }
      }
      if (DateTime.fromJSDate(new Date(filterDateValue)).hasSame(DateTime.fromJSDate(new Date(cellDateValue)), 'day')) {
        return 0;
      } else if (DateTime.fromJSDate(new Date(cellDateValue)) < DateTime.fromJSDate(new Date(filterDateValue))) {
        return -1;
      } else if (DateTime.fromJSDate(new Date(cellDateValue)) > DateTime.fromJSDate(new Date(filterDateValue))) {
        return 1;
      }
      // this should not occur.
      return NaN;
    },
  },

  dateWithTimeComparator: {
    comparator(filterDateValue: Date, cellDateValue: string): number {
      const cellDateWithoutTime = cellDateValue.split(' ')[0];

      return filterParams.dateComparator.comparator(filterDateValue, cellDateWithoutTime);
    },
  },

  percentageFilter: {
    defaultOption: 'range',
  },

  textFilterOptions: {
    filterOptions: ['contains', 'notContains'],
  },
};

export const getFilterParams = (param: FilterParamsKeys) => filterParams[param];
